import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            了解每日大赛mrds的使命与愿景
          </p>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10">
            <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-4">
              {aboutData.title}
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {aboutData.content}
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center p-4 bg-background-100 rounded-xl">
                  <div className="font-heading font-bold text-lg md:text-2xl text-primary-500 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}